import PageContentAdmin from './PageContentAdmin';

const TermsAdmin = () => (
  <PageContentAdmin
    slug="terms"
    label="Terms of Service"
    publicPath="/terms"
    helpText={
      <>
        Content is stored as HTML — you can use{' '}
        <code className="bg-gray-100 px-1 rounded">&lt;h2&gt;</code>,{' '}
        <code className="bg-gray-100 px-1 rounded">&lt;p&gt;</code>,{' '}
        <code className="bg-gray-100 px-1 rounded">&lt;strong&gt;</code>,{' '}
        <code className="bg-gray-100 px-1 rounded">&lt;ul&gt;/&lt;li&gt;</code>{' '}
        and the special{' '}
        <code className="bg-gray-100 px-1 rounded">
          &lt;p class=&quot;acl-notice&quot;&gt;
        </code>{' '}
        wrapper for the Australian Consumer Law block (renders with the blue call-out).
      </>
    }
  />
);

export default TermsAdmin;
